import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import Loader from "../../../common/components/Loader.tsx";
import { FormType } from "../../../common/enums/sharedEnums.ts";
import { RootState } from "../../../store";
import BuildingForm from "../components/BuildingForm";
import { IBuilding } from "../reducers";
import { getBuilding } from "../services";



const BuildingFormContainer = () => {
  const { id } = useParams<{
    id: string;
  }>();

  const referentials = useSelector(
    (state: RootState) => state.referentialReducer.referentials,
  );

  const {
    isLoading,
    error,
    data: building,
  } = useQuery<IBuilding, Error, IBuilding>(
    ["building", id],
    () => getBuilding(id),
    {
      enabled: !!id,
    },
  );

  if (isLoading && id) return <Loader />;

  if (error) {
    console.error(error);
    return <Alert variant="danger">Impossible de récupérer l'immeuble.</Alert>;
  }

  if (!building && id) {
    return (
      <Alert variant="danger">
        Erreur de récupération des données : Veuillez réessayer ultérieurement.
      </Alert>
    );
  }

  return (
    <BuildingForm
      building={building}
      referentials={referentials}
      id={id}
      formType={id ? FormType.UPDATE : FormType.CREATE}
    />
  );
};

export default BuildingFormContainer;
